export var useSectionSummary = function useSectionSummary(_ref) {
  var questions = _ref.questions;

  var getQuestionsBySectionId = function getQuestionsBySectionId(sectionId) {
    return questions.filter(function (q) {
      return q.sectionId === sectionId;
    });
  };

  return {
    getQuestionsBySectionId: getQuestionsBySectionId
  };
};